// extracted by mini-css-extract-plugin
export default {"practiceHeader":"PracticeHeader_practiceHeader__0qxdr"};